import React from 'react';
import styled from '@emotion/styled';
import { Tooltip } from './Tooltip';

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: 1px solid var(--border-subtle);
  background: transparent;
  color: var(--text-tertiary);
  font-size: 10px;
  font-weight: 600;
  cursor: help;
  flex-shrink: 0;
  transition: border-color 0.12s ease, color 0.12s ease;

  &:hover {
    border-color: var(--accent);
    color: var(--accent);
  }
`;

type Props = {
  text: string;
  maxWidth?: number;
};

export const HintIcon: React.FC<Props> = ({ text, maxWidth = 260 }) => (
  <Tooltip content={text} delay={200} maxWidth={maxWidth}>
    <Badge>?</Badge>
  </Tooltip>
);
